import { combineReducers, configureStore } from "@reduxjs/toolkit";
import roundtoSlice from "../redux/roundtoSlice";


const rootReducer = combineReducers({
  roundData: roundtoSlice,
});

export const store = configureStore({
  reducer: rootReducer,
  //   devTools: true,
});
